<template>
    <div
        class="pointer"
        :style="{ top: positionY, left: positionX }"
        ref="pointer"
    >
        <div class="pointer-wrapper">
            <span class="pointer-title"> {{ data.title }}</span>
            <hr>
            <span class="pointer-description">
                <span
                    v-if="data.description"
                >
                <div class="counter">
                    <span>počet bytov</span><span>{{ data.count_apartments }}</span>
                </div>
                <hr>
                <p class="show-flats">zobraziť byty</p>
                </span>
                <template v-else>
                    <ul class="list-unstyled mb-0">
                        <li v-if="data.state">
                            Stav:
                            <strong>
                                {{ data.state.title }}
                            </strong>
                        </li>
                        <li>
                            Úžitková plocha:
                            <strong v-html="data.usable_area"/>
                        </li>
                        <li v-if="data.logia_area">
                            Loggia:
                            <strong v-html="data.logia_area"/>
                        </li>
                        <li v-if="data.balcony_area">
                            Balkón:
                            <strong v-html="data.balcony_area"/>
                        </li>
                    </ul>
                </template>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="44" viewBox="0 0 25 44" fill="none">
                <path d="M0 44L25 19L0 0.5V44Z" fill="white"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array | Object,
        posY: Number,
        posX: Number,
    },
    computed: {
        positionY() {
            return this.posY - 195 + 'px';
        },
        positionX() {
            return this.posX + 20 + 'px';
        },
    },
    mounted() {
        /*this.$refs.pointer.style.top = `${this.posY /!*$('.areal')[0].clientHeight*!/ - (this.$refs.pointer.clientHeight * 1)}px`;
        this.$refs.pointer.style.left = `${($('.areal')[0].clientWidth / 2) - (this.$refs.pointer.clientWidth / 2)}px`;*/
    },
};
</script>

<style lang="scss" scoped>
.pointer {
    position: absolute;
    padding: 18px 28px;
    width: 345px;
    pointer-events: none;
    background: rgba(255, 255, 255, 1);
    border-radius: .25rem;
    z-index: 5;
    // transition: top 0.2s, left 0.2s;
    @media (max-width: 576px) {
                width: 200px;
            }

    &-wrapper {
        position: relative;

        .pointer-description {
            font-size: .875rem;
            font-weight: 600;
            letter-spacing: 0.08em;
            color: #202C5C;
            display: block;

            @media (max-width: 576px) {
                font-size: .825rem;
            }
            .counter {
                font-weight: 700;
                color: #231E1E;
                display: flex;
                justify-content: space-between;
                font-size: 1rem;
                span:first-of-type {
                    font-weight: 500;
                }
                span:last-of-type {
                    margin-left: auto;
                }
                @media (max-width: 576px) {
                font-size: .825rem;
            }
            }
            .show-flats {
                color: #E1B069;
                text-decoration: underline;
            }

            ul {
                font-weight: 400;

                strong {
                    font-weight: 600;
                }
            }
        }

        .pointer-title {
            display: block;
            color: #453813;
            font-weight: 700;
            font-size: 1.5rem;

            @media (max-width: 576px) {
                font-size: 1rem;
            }
        }

        svg {
            position: absolute;
            bottom: -30px;
            left: -28px;
        }
    }
}
</style>
